import {
  Button,
  Dialog, DialogContent,
  DialogDescription, DialogFooter,
  DialogHeader, DialogTitle,
} from '@/components/ui'
import type { WorkflowRunNode } from '@/types'
import { AlertTriangle, SkipForward } from 'lucide-react'

interface Props {
  node: WorkflowRunNode | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: (nodeId: string) => void
  isPending?: boolean
}

export function SkipNodeDialog({ node, open, onOpenChange, onConfirm, isPending }: Props) {
  if (!node) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-600">
            <SkipForward className="h-4 w-4" /> Skip Node
          </DialogTitle>
          <DialogDescription>
            Skip &ldquo;{node.name}&rdquo;?
          </DialogDescription>
        </DialogHeader>

        <div className="flex items-start gap-2 text-sm text-amber-700 bg-amber-50 p-3 rounded border border-amber-200">
          <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
          <div>
            <p className="font-medium">This will skip the node and may cascade.</p>
            <p className="text-xs mt-1">
              In sequential branches, all subsequent nodes after this one will also be skipped.
              If this was the last active node, the branch will complete or fail depending on other node results.
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button
            variant="destructive"
            disabled={isPending}
            onClick={() => { onConfirm(node.id); onOpenChange(false) }}
          >
            <SkipForward className="h-3 w-3 mr-1" /> Skip Node
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
